module.exports = __webpack_public_path__ + "static/programming-3362f01878fb3ee96bb397fef5718317.png";